import { useEffect } from 'react';
import { CuredApiPaths } from 'models/enums';
import Card from 'pages/InsightsPage/dashboards/Card';
import { FiltersForApiState } from 'pages/InsightsPage/dashboards/filtering/types';
import useFilteredData from 'pages/InsightsPage/dashboards/filtering/useFilteredData';
import StackedBarGraph from 'pages/InsightsPage/visualizations/StackedBarGraph';

type Props = {
    filtersForApi: FiltersForApiState;
};

const stackedBarLabels = {
    answered: 'Calls Answered',
    attempted: 'Calls Attempted',
};

const stackedBarColors = {
    answered: '#A7D1D0',
    attempted: '#6ab0ff',
};

const CallsAttemptedAnsweredOverTimeCard = ({ filtersForApi }: Props) => {
    const { getData, isError, isLoading, data } = useFilteredData({
        key: 'voice-dashboard/call-attempted-answered-over-time',
        path: CuredApiPaths.REPORT_VOICE_CALL_ATTEMPTED_ANSWERED_OVER_TIME,
    });

    useEffect(() => {
        getData(filtersForApi);
    }, [filtersForApi, getData]);

    // Transform data to show correct stacked values
    const transformDataForStackedBars = (rawData: any[]) => {
        if (!rawData || !Array.isArray(rawData)) return [];

        return rawData.map((item) => {
            const attempted = Number(item.values?.attempted || 0);
            const answered = Number(item.values?.answered || 0);

            return {
                id: item.id,
                barHeightValues: {
                    answered: answered, // Show answered calls at bottom
                    attempted: Math.max(0, attempted - answered), // Show unanswered calls on top
                },
                // Store original values for tooltip
                value: {
                    answered: answered,
                    attempted: attempted,
                },
            };
        });
    };

    const transformedData = transformDataForStackedBars(data);

    return (
        <Card isError={isError} isLoading={isLoading} label="Calls Attempted vs Answered by Time">
            <StackedBarGraph
                bottomLegendLabel="time"
                data={transformedData}
                leftLegendLabel="number of calls"
                stackedBarLabels={stackedBarLabels}
                stackedBarColors={stackedBarColors}
            />
        </Card>
    );
};

export default CallsAttemptedAnsweredOverTimeCard;
